import axios from 'axios';
import { resolveApiBaseUrl, rewriteStaleApiRequest } from '../utils/resolveApiBaseUrl';
import { getSimSessionId, SIM_SESSION_HEADER } from '../utils/simSession';

function applyApiBaseUrl(config) {
  const base = resolveApiBaseUrl();
  config.baseURL = base;
  axios.defaults.baseURL = base;
  rewriteStaleApiRequest(config);
  return config;
}

axios.defaults.baseURL = resolveApiBaseUrl();
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  applyApiBaseUrl(config);
  if (config.withCredentials === undefined) config.withCredentials = true;
  const sessionId = getSimSessionId();
  if (sessionId) {
    config.headers = config.headers || {};
    config.headers[SIM_SESSION_HEADER] = sessionId;
  }
  return config;
});

export default axios;
